export const locale = {
    "USER": {
        "SETTINGS": {
            "TITLE": "User settings",
            "NOTIFICATIONS": "Show notifications",
            "DISPLAY_DELETED": "Display deleted items",
        },
    }
}